export type GlobalEventsDict = {
    [name: string]: Function[]
};

const events: GlobalEventsDict = {};

export function registerGlobalEvent(name: string, callback: Function) {
    if (events[name] === undefined) {
        return events[name] = [callback];
    }
    events[name].push(callback);
}

export function triggerGlobalEvent(name: string) {
    if (events[name] !== undefined) {
        for (let i = 0; i < events[name].length; i++) {
            events[name][i]();
        }
    }
}